<div class="outer-container" fxLayout="column">

  <!-- Title -->
  <div class="top-container" fxLayout="row" fxLayoutAlign="start center">
    <div class="title" fxLayoutAlign="start center">
      {{ !classDataInitialized ? '' : className | uppercase }}
    </div>
    <div class="heading-button" fxLayoutAlign="end center" *ngIf="showCreateAssignments">
      <button mat-button (click)="openDialog()" type="button" class="cancel-button button">Quick
        Add</button>&nbsp;&nbsp;&nbsp;&nbsp;
      <button mat-button (click)="openAdvanceAssignDialog()" type="button" class="submit-button button">Advanced
        Assign</button>
    </div>
  </div>

  <!-- Filters -->

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" class="form-field-container">
    <!-- Class Filter -->
    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Select Class</mat-label>
        <input placeholder="Ex. Mathematics" matInput [formControl]="classControl" [matAutocomplete]="class">
        <mat-autocomplete #class="matAutocomplete" (optionSelected)="classChanged($event.option.id)">
          <mat-option *ngFor="let class of filteredClass | async" [value]="class.ClassName" [id]="class.HBClassID">
            {{ class.ClassName }}
          </mat-option>
        </mat-autocomplete>
        <span mat-icon-button matSuffix (click)="clearClassValue()">
          <mat-icon class="clear-icon">{{ classControl.value?.length ? 'highlight_off': ''}}</mat-icon>
        </span>
      </mat-form-field>
    </div>

    <!-- Fake inputs to disable Chrome Autocomplete on newer version -->
    <input style="opacity: 0;position: absolute;">
    <input type="password" style="opacity: 0;position: absolute;">

    <!-- Lesson Filter -->
    <div fxLayout="row" class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Search Lesson</mat-label>
        <input matInput [(ngModel)]="searchLessonValue" (keyup)="applyLessonFilter()" placeholder="Ex. Mathematics">
        <span mat-icon-button matSuffix (click)="clearLessonValue()">
          <mat-icon class="clear-icon">{{ searchLessonValue.length ? 'highlight_off': ''}}</mat-icon>
        </span>
      </mat-form-field>
    </div>

    <!-- Student Filter -->
    <div fxLayout="row" class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>Search Student</mat-label>
        <input matInput [(ngModel)]="searchStudentValue" (keyup)="applyStudentFilter()" placeholder="Ex. John Doe" autocomplete="nope">
        <span mat-icon-button matSuffix (click)="clearStudentValue()">
          <mat-icon class="clear-icon">{{ searchStudentValue.length ? 'highlight_off': ''}}</mat-icon>
        </span>
      </mat-form-field>
    </div>

    <!-- Filter for needs attention -->
    <div fxLayout="row" fxLayoutAlign="flex-end">
      <app-filter [route]="'class'" style="margin-right: 20px;"></app-filter>
    </div>
  </div>

  <!-- Spinner -->
  <div *ngIf="!classDataInitialized" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>


  <ng-container *ngIf="classDataInitialized && !needsAttentionFilterEmpty && !noCurriculum">

    <!-- <div class="expand-collapse-container">
      <span class="collapse-units" (click)="onCollapseAllUnits()">
        Collapse All Units
      </span>
      <span class="expand-units" (click)="onExpandAllUnits()">
        Expand All Units
      </span>
    </div> UNCOMMENT TO SHOW THE EXPAND AND COLLAPSE ALL FUNCTIONS -->

    <!-- Table of lessons and students -->
    <div class="mat-elevation-z0 drag-table" style="overflow-x: scroll; overflow-y: hidden; width: 100%;">
      <table mat-table [dataSource]="dataSource" [trackBy]="trackByID">
        <ng-container *ngFor="let column of headerArray; let i = index" [matColumnDef]="column.lessonVersionID"
          [sticky]="i === 0 ? true: false">
          <th [ngStyle]="{
                      'width.px': column.width,
                      'min-width.px': column.width == 'auto' ? '120' : column.width,
                      'padding-left.px': column.width == 'auto' ? '10' : '1',
                      'padding-right.px': column.width == 'auto' ? '10' : '1'
                    }" mat-header-cell *matHeaderCellDef class="assignment-header">
            <div>
              <mat-checkbox class="assignment-checkbox"  *ngIf="showCreateAssignments"
                [hidden]="!(column.width == 'auto' && column.assignmentName !== 'Student')"
                (change)="onLessonCheckboxClick($event.checked, column)"
                [ngModel]="this.selectedAssignmentsObject[column.lessonVersionID]?.selected">
              </mat-checkbox>
              <span (click)="onAssignmentClick(column)">
                {{ column.width == 'auto' ? column.assignmentName : null }}
              </span>
            </div>
          </th>
          <td mat-cell *matCellDef="let element"
            [ngClass]="{
                        'not-filtered': (filterValue.selectedFilter !== 'common' && !element[column.lessonVersionID]?.filtered),
                        'common-filter': (filterValue.selectedFilter === 'common' && column.lessonVersionID !=='Student') }" [ngStyle]="{
                        'background-color': column.width == 'auto' ? element[column.lessonVersionID]?.status : 'white',
                        'width.px': column.width,
                        'min-width.px': column.width == 'auto' ? '120' : column.width,
                        'padding-left.px': column.width == 'auto' ? '10' : '1',
                        'padding-right.px': column.width == 'auto' ? '10' : '1'
                      }" (click)="onCellClick(element, column)"
            [matTooltip]="element[column.lessonVersionID]?.statusLabel" [matTooltipShowDelay]="500">
            {{ column.width == 'auto' ? element[column.lessonVersionID]?.cellValue : null }}
          </td>
        </ng-container>

        <ng-container *ngFor="let unit of unitHeadersToDisplay; let i = index" [matColumnDef]="unit.label">
          <th mat-header-cell *matHeaderCellDef class="unit-header" [matTooltip]="unit.hidden ? unit.label : null"
            style.text-align="center"
                              [attr.colspan]="unit.count"
                              [ngStyle]="{
                                'width.px': collapsedWidth,
                                'min-width.px': collapsedWidth,
                                'padding.px': unit.hidden ? '0': '5',
                                'padding-right.px': unit.hidden ? '0' : '20'}">
            <mat-icon class="expand-icon" *ngIf="unit.hidden && unit.label !== 'StudentUnit'"
              (click)="onMaximizeClick(i)">add</mat-icon>
            <mat-icon class="minimize-icon" *ngIf="!unit.hidden && unit.label !== 'StudentUnit'"
              (click)="onMinimizeClick(i)">minimize</mat-icon>
            <span class="assignment-count" *ngIf="unit.hidden && unit.label !== 'StudentUnit'">
              {{ unit.count }}
            </span>
            <!-- {{ unit.label == 'StudentUnit' || unit.hidden ? '' : unit.label }} -->
            {{ unit.label == 'StudentUnit' ? '' : unit.label }}
          </th>
        </ng-container>

        <!-- <tr mat-header-row *matHeaderRowDef="unitNamesToDisplay"></tr> UNCOMMENT THIS TO SHOW UNITS -->
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="row"></tr>
      </table>
    </div>
  </ng-container>

  <div *ngIf="needsAttentionFilterEmpty" class="emptyFilterResponse">
    There are currently no students that need attention.
    <br> Use the filter icon on the top right to change the filter to another action or change it to show all to see all
    students.
  </div>
  <div *ngIf="noCurriculum" class="emptyFilterResponse">
    There is no curriculum attached to this class.
  </div>
  <!-- <mat-paginator [pageSizeOptions]="[10, 5, 15]" showFirstLastButtons></mat-paginator> -->

  <!-- Table legend describing cell color  -->
  <div *ngIf="classDataInitialized" fxFlex fxLayout="row wrap" fxLayoutAlign="space-around"
    class="color-indicator-container" fxLayoutGap="15px grid">
    <div *ngFor="let colorIndicator of colorIndicators" class="color-indicator">
      <span class="status-color" [ngStyle]="{'background-color': colorIndicator.color}">
      </span>
      <span class="status-label">
        {{ colorIndicator.label }}
      </span>
    </div>
  </div>
</div>
